import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class VersionSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    createdBy: { key: 'user_id', embedded: 'always' },
    entry: 'entry_id',
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'versions' || key === 'version') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
      return super.modelNameFromPayloadKey('budget-forecast/version');
    }

    if (key === 'users') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
      return super.modelNameFromPayloadKey('budget-forecast/user');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return super.modelNameFromPayloadKey(key);
  }
}
